import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class MedicalContact extends DynamicFieldsSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      notes: '',
      priority: 9,
      permissionToContact: false,
      startDate: '',
      endDate: '',
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
